import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scrolls to top on route change. Skips if a hash anchor is present. */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) {
            window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
        }
    }, [pathname, hash]);
    return null;
}
